module.exports = __webpack_public_path__ + "img/prix-de-la-maison.aca81371.png";